import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStakeholdersSectionStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: designTokens.spacing[4],
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: projectIqTokens.ink,
    margin: "0",
    fontFamily: projectIqTokens.fontFamily,
  },
  adminListWrapper: {
    marginLeft: `-${designTokens.spacing[6]}`,
    marginRight: `-${designTokens.spacing[6]}`,
  },
  divider: {
    marginBottom: designTokens.spacing[2],
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: designTokens.spacing[3],
  },
  heading: {
    fontSize: "16px",
    fontWeight: "700",
    color: projectIqTokens.ink,
    margin: "0",
    fontFamily: projectIqTokens.fontFamily,
  },
  emptyState: {
    padding: `${designTokens.spacing[6]} ${designTokens.spacing[4]}`,
    textAlign: "center",
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.muted,
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
  },
  table: {
    backgroundColor: projectIqTokens.card,
    border: `1px solid ${projectIqTokens.line}`,
    borderRadius: designTokens.borderRadius.lg,
    overflow: "hidden",
  },
  tableHeaderCell: {
    fontSize: designTokens.fontSize.sm,
    fontWeight: "600",
    color: projectIqTokens.ink2,
  },
  tableRow: {
    ":hover": {
      backgroundColor: projectIqTokens.bg2,
    },
  },
  tableCell: {
    fontSize: designTokens.fontSize.sm,
    color: projectIqTokens.ink2,
  },
  actionsCell: {
    display: "flex",
    gap: designTokens.spacing[1],
    justifyContent: "flex-end",
  },
});
